import React, {Component} from 'react';
import './Toggle.css';

export default class Toggle extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
            updateState: this.updateState
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event){
        let _checked = event.target.getAttribute('data-checked').toString() === "true";
        this.setState({checked: !_checked});
        this.props.updateState(!_checked);
    }
    render() {
        return (<div className="custom-control custom-switch">
            <input type="checkbox" onChange={this.handleChange} className="custom-control-input" checked={this.props.checked}/>
            <label className="custom-control-label" 
                data-checked={this.props.checked} 
                onClick={this.handleChange} 
                htmlFor="customSwitch1">{this.props.label}</label>
            </div> 
        );
    }
}